<template>
    <div>

        <ul class="nav nav-tabs" role="tablist">
            <li role="presentation" class="active">
                <a :href="tab1href" role="tab" data-toggle="tab">
                    {{ t('Competition') }}
                </a>
            </li>
            <li role="presentation">
                <a :href="tab2href" ref="history-tab" role="tab" data-toggle="tab" @click="loadHistory">
                    {{ t('Price history') }}
                </a>
            </li>
            <li role="presentation">
                <a :href="tab3href" ref="chart-tab" role="tab" data-toggle="tab" @click="loadChart">
                    {{ t('Chart') }}
                </a>
            </li>
        </ul>

        <br />

        <div class="tab-content">
            <div role="tabpanel" class="tab-pane active" :id="tab1ID">


                <label>
                    <input type="checkbox" v-model="onlyPriceChanged" @change="loadCompetitors" /> Tylko ze zmieniona ceną
                </label>

                <br />

                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:15px;"></th>
                            <th>{{ t('Store') }}</th>
                            <th>{{ t('Product') }}</th>
                            <th>{{ t('Price') }}</th>
                            <th>{{ t('Previous price') }}</th>
                            <th>{{ t('Different') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(competitor, index) in competitors">
                            <td>{{ index+1 }}</td>
                            <td><span class="glyphicon" v-bind:class="{'glyphicon-arrow-up': competitor.diff > 0, 'glyphicon-arrow-down': competitor.diff < 0}"></span> {{ competitor.shop_name }} </td>
                            <td><a :href="competitor.link" target="_blank">{{ competitor.name }}</a></td>
                            <td>{{ competitor.curr_price }}</td>
                            <td>{{ competitor.prev_price }}</td>
                            <td><a href="#" @click="openHistory(competitor.id)">{{ competitor.percent }}%</a></td>
                        </tr>
                    </tbody>
                </table>

            </div>
            <div role="tabpanel" class="tab-pane" :id="tab2ID" >

                <div class="row">
                    <div class="col-lg-12">


                        <div class="text-center">

                            <select v-model="selectedProductHistory" class="form-control" @change="loadHistory">
                                <option value="0">{{ t('Select product') }}</option>
                                <option v-for="(competitor, index) in competitors" v-bind:value="competitor.id">{{ index+1 }}. {{ competitor.shop_name }} / {{ competitor.name }}</option>
                            </select>
                        </div>

                        <br /><br />

                        <table class="table">
                            <thead>
                            <tr>
                                <th style="width:150px">{{ t('Date') }}</th>
                                <th style="width:150px">{{ t('Price') }}</th>
                                <th >{{ t('Promotion') }}</th>
                            </tr>
                            </thead>
                            <tbody v-show="history.length > 0">

                            <tr v-for="item in history">
                                <td>{{ item.date }}</td>
                                <td>{{ item.price }}</td>
                                <td><span class="glyphicon glyphicon-ok" v-show="item.promo == 1"></span></td>
                            </tr>
                            </tbody>
                        </table>

                    </div>
                </div>

            </div>
            <div role="tabpanel" class="tab-pane" :id="tab3ID" >

                <br />

                <div style="height:350px;">
                    <default-chart  :labels="chart.labels" :items="chart.data"  :height="120"></default-chart>
                </div>

            <div class="clearfix"></div>

            </div>
        </div>

    </div>
</template>

<script>
    require('bootstrap');

    import DefaultChart from '../DefaultChart';

    export default {
        data() {
            return {
                competitors: [],
                onlyPriceChanged: true,
                refresh: false,
                selectedProductHistory: 0,
                history: [],
                chart: {
                    labels: [],
                    data: [],
                },
            };
        },
        components: {
            DefaultChart
        },
        mounted() {
            this.init();
        },
        computed: {
            tab1ID() {
                return 'tab1_' + this.$data.id
            },
            tab2ID() {
                return 'tab2_' + this.$data.id
            },
            tab3ID() {
                return 'tab3_' + this.$data.id
            },
            tab1href() {
                return '#tab1_' + this.$data.id
            },
            tab2href() {
                return '#tab2_' + this.$data.id
            },
            tab3href() {
                return '#tab3_' + this.$data.id
            },
        },
        methods: {
            customLabel (option) {
                return `${option.id} - ${option.name}`
            },
            openHistory: function(id)
            {
                this.$refs['history-tab'].click();
                this.selectedProductHistory = id;
                this.loadHistory();
            },
            init: function() {
                this.onlyPriceChanged = this.$data.priceChanged;

                this.loadCompetitors();
            },
            loadCompetitors: function()
            {
                this.$http.get('price-change-detector/competitors', {params: {
                    id: this.$data.id,
                    category: this.$data.category,
                    price_changed: this.onlyPriceChanged ? 1 : 0,
                }}).then(response => {
                    this.competitors = response.body;
                });
            },
            loadHistory: function()
            {
                this.$http.get('price-change-detector/price-history/'+this.$data.key, {params: {id: this.selectedProductHistory}}).then(response => {
                    this.history = response.body;
                });
            },
            loadChart: function()
            {
                if (!this.chart.labels.length)
                {
                    this.$http.get('price-change-detector/chart/'+this.$data.key, {params: {id: this.$data.id}}).then(response =>
                    {
                        this.chart.labels = response.body.labels;
                        this.chart.data = response.body.data;
                    });
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// details.vue?3792b8ee